define((require) => {
    "use strict";

    const _        = require("underscore");
    const Class    = require("shared/util/Class");
    const Backbone = require("backbone");

    /**
     * Abstract base class providing event dispatcher and listen-to functionality utilizing Backbone.Events.
     *
     * This class may be useful if you need basic event logic.
     *
     * @class EventDispatcher
     */

    const EventDispatcher = function() {}; // TODO: bad name, since both dispatch and listening - why not simply Events?

    EventDispatcher.extend = Class.extend;

    _.extend(EventDispatcher.prototype, Backbone.Events);

    return EventDispatcher;
});



// WEBPACK FOOTER //
// ./src/shared/util/EventDispatcher.js